// Environment-based configuration
const getApiBaseUrl = (): string => {
  // Check if we have environment variable
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Default based on NODE_ENV
  const isDevelopment = process.env.NODE_ENV === 'development';
  return isDevelopment ? 'http://localhost:5000' : `${process.env.REACT_APP_API_URL}`;
};

export const API_BASE_URL = getApiBaseUrl();

// Login URL configuration
export const LOGIN_URL = process.env.REACT_APP_LOGIN_URL || 'http://localhost:3001/api/auth/login';

export const API_ENDPOINTS = {
  // Products
  products: `${API_BASE_URL}/api/products`,
  productsFilter: `${API_BASE_URL}/api/products/filter`,

  // Categories
  categories: `${API_BASE_URL}/api/categories`,
  categoriesMain: `${API_BASE_URL}/api/categories/main`,
  categoriesAllSub: `${API_BASE_URL}/api/categories/all-sub`,
  categoriesSub: (id: string) => `${API_BASE_URL}/api/categories/sub/${id}`,

  // Departments
  departments: `${API_BASE_URL}/api/departments`,
  departmentOffices: (id: string) => `${API_BASE_URL}/api/departments/${id}/offices`,

  // Users
  users: `${API_BASE_URL}/api/users`,
  usersFindByPhone: `${API_BASE_URL}/api/users/find-by-phone`,

  // Tickets
  tickets: `${API_BASE_URL}/api/tickets`,
  ticketsBalance: (userId: number) => `${API_BASE_URL}/api/tickets/balance/${userId}`,
  ticketsPurchase: `${API_BASE_URL}/api/tickets/purchase`,
  ticketsUse: `${API_BASE_URL}/api/tickets/use`,
  ticketsTransactions: (userId: number) => `${API_BASE_URL}/api/tickets/transactions/${userId}`,
  ticketsPurchases: (userId: number) => `${API_BASE_URL}/api/tickets/purchases/${userId}`,
  ticketsAdminTransactions: `${API_BASE_URL}/api/tickets/admin/transactions`,

  // Auth
  login: LOGIN_URL,
};

// Environment utilities
export const CONFIG = {
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
  apiTimeout: parseInt(process.env.REACT_APP_API_TIMEOUT || '10000'),
  enableLogging: process.env.REACT_APP_ENABLE_LOGGING === 'true',
};
